import { hasString } from './guards'

export const isBetween = (value: number, min: number, max: number) =>
  value >= min && value <= max

export const getPercentageBetween = (
  value1: number,
  value2: number,
  min: number,
  max: number
) => {
  if (value1 < min || value2 < min || value1 > max || value2 > max) {
    throw new Error(
      `Values must be within specified range. range low: ${value1}, range high: ${value2}, min: ${min}, max: ${max}`
    )
  }

  return Math.abs((Math.abs(value2 - value1) / (max - min)) * 100)
}

export const debug = (value: unknown) =>
  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  JSON.stringify(value, null, 2)

export const localeIncludes = (
  str: string,
  searchStr: string,
  {
    normalize = false,
    position = 0,
    ...options
  }: {
    normalize?: boolean
    position?: number
    sensitivity?: 'base' | 'accent' | 'case' | 'variant'
  } & Intl.CollatorOptions = {}
) => {
  if (!hasString(str)) {
    return false
  }
  if (!hasString(searchStr)) {
    return true
  }

  // if normalize ignore white spaces and separate accent characters
  const diacriticalMarks = /[\u0300-\u036f]/g
  const normalizedString = normalize
    ? str.replace(diacriticalMarks, '').replace(/ /g, '')
    : str
  const normalizedSearchString = normalize
    ? searchStr.replace(diacriticalMarks, '').replace(/ /g, '')
    : searchStr

  // look at the each possible substring in the normalizedString and compare it with normalizedSeachString
  // by default it ignores accents and case sensitivity, this can be adjusted by setting sensitivity param
  const normalizedSearchStringLength = normalizedSearchString.length
  const lengthDiff = normalizedString.length - normalizedSearchStringLength
  for (let i = position; i <= lengthDiff; i++) {
    if (
      normalizedString
        .substring(i, i + normalizedSearchStringLength)
        .localeCompare(normalizedSearchString, undefined, {
          sensitivity: 'base',
          ...options,
        }) === 0
    ) {
      return true
    }
  }

  return false
}
